/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import2 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import3 from '../../orchestration/page';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from 'ng2-translate/src/translate.pipe';
import * as import6 from 'ng2-translate/src/translate.service';
import * as import7 from '../../legal/legal-panel/legal-panel.component.ngfactory';
import * as import8 from '../../legal/legal-panel/legal-panel.component';
import * as import9 from '../../orchestration/analytics.service';
import * as import10 from './age-verification-page.component';
import * as import11 from '../../buttons/button/button.component.ngfactory';
import * as import12 from '../../buttons/button/button.component';
import * as import13 from '../../orchestration/session.model';
import * as import14 from '../../orchestration/responsive.service';
import * as import15 from '../../page-layout/page-footer-control.directive';
import * as import16 from '../../ordering-context/ordering-context.model';
const styles_AgeVerificationPageComponent:any[] = ([] as any[]);
export const RenderType_AgeVerificationPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_AgeVerificationPageComponent,
  data: {}
}
);
export function View_AgeVerificationPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),29,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import1.View_ModalPageLayoutComponent_0,import1.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import2.ModalPageLayoutComponent,[
      import3.Page,
      import4.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
    import0.ɵpod(['minimumAge']),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import3.PageLayout,(null as any),[import2.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,3,'div',[[
        'class',
        'age-indicator'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    import0.ɵpod(['minimumAge']),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,2,'woa-legal-panel',[[
        'class',
        'age-legal'
      ]
    ],(null as any),(null as any),(null as any),import7.View_LegalPanelComponent_0,import7.RenderType_LegalPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import8.LegalPanelComponent,[
      import9.AnalyticsService,
      import4.NavigationService
    ]
    ,{
      messageSet: [
        0,
        'messageSet'
      ]
      ,
      messageParams: [
        1,
        'messageParams'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['minimumAge']),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,2,'div',[[
        'class',
        'age-disclaimer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),7,3,'woa-button',[
      [
        'id',
        'confirm-under-age-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.AgeVerificationPageComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,22).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.navigationService.dismissPage(co)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import11.View_ButtonComponent_0,import11.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import12.ButtonComponent,[
      import0.ElementRef,
      import13.SessionModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['minimumAge']),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import15.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),7,3,'woa-button',[
      [
        'id',
        'confirm-over-age-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.AgeVerificationPageComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,27).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.navigationService.dismissPage(co,true)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import11.View_ButtonComponent_0,import11.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import12.ButtonComponent,[
      import0.ElementRef,
      import13.SessionModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['minimumAge']),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import15.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import10.AgeVerificationPageComponent = v.component;
    const currVal_0:any = 'woa.heading.age-verification.title';
    const currVal_1:any = ck(v,5,0,co.orderingContextModel.currentStore.minimumAge);
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_3:any = 'age-verification';
    const currVal_4:any = ck(v,15,0,co.orderingContextModel.currentStore.minimumAge);
    ck(v,14,0,currVal_3,currVal_4);
    const currVal_33:any = 'woa.button.age-verification.under';
    const currVal_34:any = ck(v,23,0,co.orderingContextModel.currentStore.minimumAge);
    const currVal_35:any = co.ButtonProminence.LOW;
    ck(v,22,0,currVal_33,currVal_34,currVal_35);
    const currVal_63:any = 'woa.button.age-verification.over';
    const currVal_64:any = ck(v,28,0,co.orderingContextModel.currentStore.minimumAge);
    ck(v,27,0,currVal_63,currVal_64);
  },(ck,v) => {
    var co:import10.AgeVerificationPageComponent = v.component;
    const currVal_2:any = import0.ɵunv(v,9,0,import0.ɵnov(v,11).transform('woa.message.age-verification.details',ck(v,10,0,co.orderingContextModel.currentStore.minimumAge)));
    ck(v,9,0,currVal_2);
    const currVal_5:any = import0.ɵunv(v,18,0,import0.ɵnov(v,19).transform('woa.message.age-verification.disclaimer'));
    ck(v,18,0,currVal_5);
    const currVal_6:any = import0.ɵnov(v,22).overrideFlatBackgroundColor;
    const currVal_7:any = import0.ɵnov(v,22).overrideFlatForegroundColor;
    const currVal_8:any = import0.ɵnov(v,22).overrideOutlineBackgroundColor;
    const currVal_9:any = import0.ɵnov(v,22).overrideOutlineForegroundColor;
    const currVal_10:any = import0.ɵnov(v,22).overrideOutlineBorderColor;
    const currVal_11:any = import0.ɵnov(v,22).overrideRaisedBackgroundColor;
    const currVal_12:any = import0.ɵnov(v,22).overrideRaisedForegroundColor;
    const currVal_13:any = import0.ɵnov(v,22).disabled;
    const currVal_14:any = import0.ɵnov(v,22).invisible;
    const currVal_15:any = import0.ɵnov(v,22).hovered;
    const currVal_16:any = import0.ɵnov(v,22).native;
    const currVal_17:any = import0.ɵnov(v,22).button;
    const currVal_18:any = import0.ɵnov(v,22).firstTier;
    const currVal_19:any = import0.ɵnov(v,22).secondTier;
    const currVal_20:any = import0.ɵnov(v,22).highProminence;
    const currVal_21:any = import0.ɵnov(v,22).lowProminence;
    const currVal_22:any = import0.ɵnov(v,22).affirmativeConnotation;
    const currVal_23:any = import0.ɵnov(v,22).dissuasiveConnotation;
    const currVal_24:any = import0.ɵnov(v,22).negativeConnotation;
    const currVal_25:any = import0.ɵnov(v,22).squareShape;
    const currVal_26:any = import0.ɵnov(v,22).roundedShape;
    const currVal_27:any = import0.ɵnov(v,22).ovalShape;
    const currVal_28:any = import0.ɵnov(v,22).flatStyle;
    const currVal_29:any = import0.ɵnov(v,22).outlineStyle;
    const currVal_30:any = import0.ɵnov(v,22).raisedStyle;
    const currVal_31:any = import0.ɵnov(v,22).verticalLayout;
    const currVal_32:any = import0.ɵnov(v,22).horizontalLayout;
    ck(v,21,1,[
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26,
      currVal_27,
      currVal_28,
      currVal_29,
      currVal_30,
      currVal_31,
      currVal_32
    ]
    );
    const currVal_36:any = import0.ɵnov(v,27).overrideFlatBackgroundColor;
    const currVal_37:any = import0.ɵnov(v,27).overrideFlatForegroundColor;
    const currVal_38:any = import0.ɵnov(v,27).overrideOutlineBackgroundColor;
    const currVal_39:any = import0.ɵnov(v,27).overrideOutlineForegroundColor;
    const currVal_40:any = import0.ɵnov(v,27).overrideOutlineBorderColor;
    const currVal_41:any = import0.ɵnov(v,27).overrideRaisedBackgroundColor;
    const currVal_42:any = import0.ɵnov(v,27).overrideRaisedForegroundColor;
    const currVal_43:any = import0.ɵnov(v,27).disabled;
    const currVal_44:any = import0.ɵnov(v,27).invisible;
    const currVal_45:any = import0.ɵnov(v,27).hovered;
    const currVal_46:any = import0.ɵnov(v,27).native;
    const currVal_47:any = import0.ɵnov(v,27).button;
    const currVal_48:any = import0.ɵnov(v,27).firstTier;
    const currVal_49:any = import0.ɵnov(v,27).secondTier;
    const currVal_50:any = import0.ɵnov(v,27).highProminence;
    const currVal_51:any = import0.ɵnov(v,27).lowProminence;
    const currVal_52:any = import0.ɵnov(v,27).affirmativeConnotation;
    const currVal_53:any = import0.ɵnov(v,27).dissuasiveConnotation;
    const currVal_54:any = import0.ɵnov(v,27).negativeConnotation;
    const currVal_55:any = import0.ɵnov(v,27).squareShape;
    const currVal_56:any = import0.ɵnov(v,27).roundedShape;
    const currVal_57:any = import0.ɵnov(v,27).ovalShape;
    const currVal_58:any = import0.ɵnov(v,27).flatStyle;
    const currVal_59:any = import0.ɵnov(v,27).outlineStyle;
    const currVal_60:any = import0.ɵnov(v,27).raisedStyle;
    const currVal_61:any = import0.ɵnov(v,27).verticalLayout;
    const currVal_62:any = import0.ɵnov(v,27).horizontalLayout;
    ck(v,26,1,[
      currVal_36,
      currVal_37,
      currVal_38,
      currVal_39,
      currVal_40,
      currVal_41,
      currVal_42,
      currVal_43,
      currVal_44,
      currVal_45,
      currVal_46,
      currVal_47,
      currVal_48,
      currVal_49,
      currVal_50,
      currVal_51,
      currVal_52,
      currVal_53,
      currVal_54,
      currVal_55,
      currVal_56,
      currVal_57,
      currVal_58,
      currVal_59,
      currVal_60,
      currVal_61,
      currVal_62
    ]
    );
  });
}
function View_AgeVerificationPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-age-verification-page',([] as any[]),(null as any),(null as any),(null as any),View_AgeVerificationPageComponent_0,RenderType_AgeVerificationPageComponent)),
    import0.ɵdid(49152,(null as any),0,import10.AgeVerificationPageComponent,[
      import4.NavigationService,
      import16.OrderingContextModel
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import3.Page,(null as any),[import10.AgeVerificationPageComponent])
  ]
  ,(null as any),(null as any));
}
export const AgeVerificationPageComponentNgFactory:import0.ComponentFactory<import10.AgeVerificationPageComponent> = import0.ɵccf('woa-age-verification-page',import10.AgeVerificationPageComponent,View_AgeVerificationPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/customer-info/age-verification-page/age-verification-page.component.ngfactory.ts